// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"e3e7be2a","137":"6f275c66","904":"aec80e21"}[chunkId] + ".chunk.css";
};